import { render, staticRenderFns } from "./MailArchiveAttachment.vue?vue&type=template&id=4efb1e14"
import script from "./MailArchiveAttachment.vue?vue&type=script&lang=js"
export * from "./MailArchiveAttachment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports